import React from "react";
import "./_static/listViews.css"
import AddNewButton from "../buttons/AddNewButton";
import TableView from "../tables/TableView";
import PreviousPage from "../buttons/PreviousPage";
import NextPage from "../buttons/NextPage";
import {useAppState} from "../AppStateContext";
import {FormControl} from "react-bootstrap";
import FullTextSearch from "./_support/FullTextSearch";
import Col from "react-bootstrap/Col";
import ExportButton from "./_support/ExportButton";


function ListViewCommon(props) {

    const {appState, updateAppState} = useAppState()

    function changePage(b_next) {
        let newPage = appState.currentPage
        if (b_next) {
            newPage += 1
        } else {
            if (newPage > 1) {
                newPage -= 1
            }
        }
        updateAppState({currentPage: newPage})
    }

    function updatePage(event) {
        let newValue = parseInt(event.target.value)
        if (newValue < 1 || isNaN(newValue)) {
            newValue = 1
        }
        updateAppState({currentPage: newValue})
    }

    return (
        <div className="mainDiv">
            <div className="topDiv row flex-row">
                <Col>
                    <AddNewButton link={`${props.baseUrlFrontend}/new`}/>
                </Col>
                <Col className="d-flex justify-content-end">
                    {props.fullTextSearch && <FullTextSearch filterUpdate={props.filterUpdate} filters={props.filters}/>}
                    {props.exportButton && <ExportButton exportUrl={props.exportUrl}/>}
                </Col>
            </div>
            <div className="tableDiv">
                <TableView filters={props.filters} filterUpdate={props.filterUpdate} links={props.links}
                           headers={props.headers} data={props.data}
                           delete_single={props.delete_single} label={props.label}
                           noColorRows={props.noColorRows}
                           deleteConfirmationText={props.deleteConfirmationText}
                           deleteConfirmation={props.deleteConfirmation}
                />
            </div>
            <div className="bottomDiv">
                <PreviousPage changePage={() => changePage(false)}/>
                <FormControl type="number" onChange={updatePage} value={appState.currentPage} style={{marginLeft:"5px", width: "100px", height:"100%"}}/>
                <NextPage changePage={() => changePage(true)}/>
            </div>
        </div>
    )
}

export default ListViewCommon
